import { IAutomationAppComponent } from "../../types";
import { schema, schemaFlow, schemaOutlet, schemaPFlow, schemaPOutlet, schemaSFlow, schemaSOutlet } from "./types";
import { OverviewPanel,OperatorPanel } from '.';
import { IconPipe } from "./IconPipe";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: IconPipe,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:  {
        group: 'SubPlants',
        name: "Pipe",
        description: "Pipe",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppFlow : IAutomationAppComponent = {
    schema: schemaFlow,
    supportsProcessPanel: false,
    Icon: IconPipe,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:  {
        group: 'SubPlants',
        name: "Flow pipe",
        description: "Flow pipe",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppOutlet: IAutomationAppComponent = {
    schema: schemaOutlet,
    supportsProcessPanel: false,
    Icon: IconPipe,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:  {
        group: 'SubPlants',
        name: "Outlet pipe",
        description: "Outlet pipe",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppPrimaryFlow: IAutomationAppComponent = {
    schema: schemaPFlow,
    supportsProcessPanel: false,
    Icon: IconPipe,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:  {
        group: 'SubPlants',
        name: "Primary flow pipe",
        description: "Primary flow pipe",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppSecondaryFlow: IAutomationAppComponent = {
    schema: schemaSFlow,
    supportsProcessPanel: false,
    Icon: IconPipe,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:  {
        group: 'SubPlants',
        name: "Secondary flow pipe",
        description: "Secondary flow pipe",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppPrimaryOutlet: IAutomationAppComponent = {
    schema: schemaPOutlet,
    supportsProcessPanel: false,
    Icon: IconPipe,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:  {
        group: 'SubPlants',
        name: "Primary outlet pipe",
        description: "Primary outlet pipe",
        panel: OverviewPanel,
        defaultState: { },
    },
}
export const AppSecondaryOutlet: IAutomationAppComponent = {
    schema: schemaSOutlet,
    supportsProcessPanel: false,
    Icon: IconPipe,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel, 
    createConfig:  {
        group: 'SubPlants',
        name: "Secondary outlet pipe",
        description: "Secondary outlet pipe",
        panel: OverviewPanel,
        defaultState: { },
    },
}